//material-ui
import { Button, ButtonProps, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from "@mui/material";
import { makeStyles, createStyles } from "@mui/styles";
import CloseIcon from "@mui/icons-material/Close";

export interface DialogActionButtons {
	children: React.ReactNode;
	props: ButtonProps;
}

const useStyles = makeStyles((theme?: any) =>
	createStyles({
		modal: {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
		},
		paper: {
			width: "100%",
		},
	})
);

interface ModalDialogProps {
	title: string;
	actions?: DialogActionButtons[] | null;
	open: boolean;
	showCloseButton?: boolean;
	close: () => void;
	children?: React.ReactNode;
}
const ModalDialog: React.FC<ModalDialogProps & React.ComponentProps<typeof Dialog>> = ({
	title,
	actions,
	open,
	showCloseButton,
	close,
	children,
	...otherProps
}) => {
	const classes = useStyles();

	const actionButtons = actions
		? actions.map(
				(action, i) =>
					action.props && (
						<Button key={i} variant="contained" {...action.props}>
							{action.children}
						</Button>
					)
		  )
		: null;

	return (
		<Dialog
			className={classes.modal}
			open={open}
			onClose={close}
			closeAfterTransition
			PaperProps={{
				className: classes.paper,
			}}
			disableEnforceFocus={true}
			disableScrollLock={true}
			{...otherProps}
		>
			{title && <DialogTitle>{title}</DialogTitle>}
			<DialogContent>
				<>
					{showCloseButton && (
						<IconButton
							aria-label="close"
							onClick={close}
							sx={{
								position: "absolute",
								right: 8,
								top: 8,
								color: (theme) => theme.palette.grey[500],
							}}
						>
							<CloseIcon />
						</IconButton>
					)}
					{children}
				</>
			</DialogContent>
			{actionButtons && actionButtons.length > 0 ? (
				<DialogActions sx={{ padding: (theme) => theme.spacing(2) + " " + theme.spacing(3) }}>{actionButtons}</DialogActions>
			) : null}
		</Dialog>
	);
};

export default ModalDialog;
